


























import { Vue, Component } from 'vue-property-decorator';

import UserManagement from './user-manager/user-management.vue';
import Workspaces from './workspaces/workspaces.vue';
import SharedReports from './shared-reports/shared-reports.vue';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import userManagerApi,{UserManagerApi} from '@/views/settings/multi-user-access/user-manager/api';
import DomainsApi from '@/services/rest/bemob/domains';
import LoadingCircle from '@/components/loading-circle.vue';
import ApiServices from '@/services';
import sharedReportsApi, {SharedReportsApi} from '@/views/settings/multi-user-access/shared-reports/api';
import { AclMixin } from '@/components/acl/acl-mixin';
import { mixins } from 'vue-class-component';


@Component({
  components: {
    UserManagement,
    Workspaces,
    SharedReports,
    LoadingCircle,
  }
})

export default class MultiUserAccess extends mixins(AclMixin) {
  tabMultiUserAccess: string = '';
  workspacesApi: WorkspacesApi = workspacesApi;
  userManagerApi: UserManagerApi = userManagerApi;
  domainsApi: DomainsApi = new DomainsApi();
  sharedReportsApi: SharedReportsApi = sharedReportsApi;

  loading: boolean = true;

  get tabs() {
    const result=[]
    if(this.canAccessPage('profile.multi-user-access:workspaces')){
      result.push({
        label: this.t('Workspaces'),
        key: 'workspaces',
      })
    }
    if(this.canAccessPage('profile.multi-user-access:user-management')){
      result.push({
        label: this.t('Users management'),
        key: 'usersManagement',
      })
    }
    if(this.canAccessPage('profile.multi-user-access:shared-reports')){
      result.push({
        label: this.t('Shared reports'),
        key: 'sharedReports',
      })
    }
    
    return result
  }

  load(): any {
    const promises = []
    if(this.canAccessPage('profile.multi-user-access:workspaces')){
      // to update elements statistic in workspace head
      ApiServices.getUserProfile()
      promises.push(this.workspacesApi.getWorkspaces())
    }
    if(this.canAccessPage('profile.multi-user-access:user-management')){
      promises.push(this.userManagerApi.getMembers())
    }
    if(this.canAccessPage('profile.multi-user-access:shared-reports')){
      promises.push(this.sharedReportsApi.getSharedReports())
    }

    return Promise.all(promises)
  }

  async mounted() {
    this.$store.commit('loading', true);
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }
    this.load().then(() => {
      this.loading = false;
      this.$store.commit('loading', false);
    });
  }
}
